import img from '../../images/Nexus_6_piccolo_display_trasparent.png'
export const styles = (theme: any) => {
    return {
        device: {
            height: '645px',
            width: '400px',
            backgroundImage: 'url(' + img + ')',
            backgroundRepeat: 'no-repeat',
            backgroundPositionX: 'left',
            backgroundPositionY: 'top',
            position: 'fixed' as 'fixed',
        },
        content: {
            margin: '8px',
            overflow: 'auto',
            //position: 'relative',
            top: '80px',
            left: '62px',
            height: '980px', // REALI height: 2560px,
            width: '520px', // REALI width: 1440px,
            transformOrigin: '0 0',
            transform: 'scale(0.5)',
            position: 'relative' as 'relative'
        },
        cropper: {
            marginBottom: '10px'
        },
        buttons: {
            marginRight: '10px',
            padding: '5px'
        }
    }
}